import { configureStore } from "@reduxjs/toolkit";
import { reducers } from "../reducer";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import reduxThunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [],
};


const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [reduxThunk],
});

export const persistor = persistStore(store);
